export function secondsUntil(timeMs: number, now: number) {
  return Math.ceil((timeMs - now) / 1000)
}

export function formatDurationSeconds(totalSeconds: number) {
  const totalWholeSeconds = Math.round(totalSeconds)
  const days = Math.floor(totalWholeSeconds / (60 * 60 * 24))
  const hours = days * 24 + (Math.floor(totalWholeSeconds / (60 * 60)) % 24)
  const minutes = Math.floor(totalWholeSeconds / 60) % 60
  const seconds = totalWholeSeconds % 60

  const pad = (n: number) => n.toString().padStart(2, '0')
  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
}
